__turbopack_context__.v({
  "vh_100": "styles-module-scss-module__lxUGWa__vh_100",
});
